/**
 * SnapLog AI 분석 클라이언트
 * 백엔드 /api/snap/analyze 래퍼
 */

/**
 * 시나리오 기반 이미지 분석
 * @param {Object} params
 * @param {File} params.imageFile - 이미지 파일
 * @param {string} params.scenario_type - 시나리오 ID
 * @param {string} params.prompt - 분석 프롬프트
 * @param {string} params.user_question - 사용자 질문 (선택)
 * @param {string} params.ai_model - AI 모델 (기본: gemini-2.0-flash)
 * @param {Function} params.onProgress - 진행 콜백
 * @returns {Promise<Object>} 분석 결과 JSON
 */
export async function analyzeSnap({
  imageFile, scenario_type, prompt,
  user_question = '', ai_model = 'gemini-2.0-flash',
  onProgress
}) {
  if (onProgress) onProgress({ stage: 'uploading', progress: 10 });

  const formData = new FormData();
  formData.append('image', imageFile);
  formData.append('scenario_type', scenario_type);
  formData.append('prompt', prompt);
  formData.append('ai_model', ai_model);
  if (user_question) {
    formData.append('user_question', user_question);
  }

  if (onProgress) onProgress({ stage: 'analyzing', progress: 30 });

  const response = await fetch('/api/snap/analyze', {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(`Analysis failed (${response.status}): ${text}`);
  }

  if (onProgress) onProgress({ stage: 'parsing', progress: 80 });

  const result = await response.json();

  if (!result.success) {
    throw new Error(result.error || 'Analysis failed');
  }

  if (onProgress) onProgress({ stage: 'complete', progress: 100 });

  return result.data.analysis_json;
}
